import * as Website from '../../Config/Website.js';
import * as InfoTab from './Modules/InfoTab.js';


const preinit = () => {

}

const init = () => {
  InfoTab.init();
}

const pageChanged = () => {
  InfoTab.init();
}

const resize = () => {
  InfoTab.resize();
}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  pageChanged,
  resize,
  resizeW,
  scroll,
  load
}